import { TariffCodeSuggestion } from '~/lib/api/smartsend/types';

export const TariffCodeCache: { [key: string]: TariffCodeSuggestion[] } = {};
